require('./consentChange.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { GDPRSignaturePatternSimple } = require('components/gdprSignaturePattern/gdprSignaturePatternSimple.js');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');

// @ constants
const { OKCONSENTS_NEGATIVE_VALUE, OKCONSENTS_CONSENTS_SWITCH } = require('constants/consents');

// @utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { buildLastStepInformation, getStateGdprConsent, recordGdprClauseInteraction } = require('utilities/consentsHelper');
const { PROC_GDPR_CONSENTS, PROC_END, recordLink } = require('utilities/tagging');


class ConsentChange extends React.Component {

    constructor(props) {
        super(props);
        this.renderConsentWizard = this.renderConsentWizard.bind(this);
        this.renderLastStepInformation = this.renderLastStepInformation.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.cancel = this.cancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.buildAdvertisement = this.buildAdvertisement.bind(this);
        this.recordGDPRResults = this.recordGDPRResults.bind(this);
    }

    recordGDPRResults(type) {
        const { immConsentsGdpr } = this.props;
        let results= '';

        immConsentsGdpr.get('consents').forEach( immConsent => {
            const id = immConsent.getIn(['consentCell', 'id']);
            const status = immConsent.get('status');
            results += `${id}:${status}|`;
        });
        results = results.substring(0, results.length-1);
        recordLink(PROC_GDPR_CONSENTS, type, results);
    }

    cancel() {
        this.props.history.push('/myprofile/edit');
    }

    onFinish() {
        this.recordGDPRResults(PROC_END);
        this.props.handleUpdateConsents();
    }

    setVisibleStep() {
        this.props.lastStep();
    }

    onGdprAcceptAll(value){
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS)
    }

    onGdprChangeValue(id, value){
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS, id);
    }

    validateStep() {
        const { nextStep } = this.props;

        this.recordGDPRResults('paso_1');
        nextStep();
    }

    buildAdvertisement(robinsonUser) {

        const advertisementLinkURL = "https://bancoonline.openbank.es/csopen/Satellite?c=DocumentoGS&canal=CWebComOB&cid=1431483031318&empr=BrokerOpenBank&leng=es_ES&pagename=BrokerOpenBank%2FDocumentoGS%2FDocumentoGSPreview";
        const advertisementElement = (
            <div className="consent-change-info__advertisement row no-gutter">
                <img
                    className="consent-change-info__advertisement-image col-xs-2"
                    src="https://www.openbank.es/assets/static/private-assets/images/GDPRSorteo.jpg"
                />
                <h2 className="consent-change-info__advertisement-title-container col-xs-10">
                    <span className="consent-change-info__advertisement-title">
                        <FormattedText value={"gdpr-interstitialPromoTitle"} />
                    </span>
                </h2>
                <section className="consent-change-info__advertisement-text-container col-xs-10">
                    <OKLink to={advertisementLinkURL} target="_blank">
                        <span className="consent-change-info__advertisement-text">
                            <FormattedText value={"gdpr-interstitialPromoLinkText"} />
                        </span>
                    </OKLink>
                </section>
            </div>
        );

        return robinsonUser ? null : advertisementElement;
    }

    renderLastStepInformation() {
        const { immConsentsGdpr } = this.props;
        const showConsentsChanges = immConsentsGdpr.get('consents').size > 0;
        const onlyConsents = immConsentsGdpr.get('consents').filter((consents) => consents.getIn(['consentCell', 'displayType']) === OKCONSENTS_CONSENTS_SWITCH);
        let consentsBuild = [];

        if (showConsentsChanges) {
            consentsBuild = onlyConsents.toJS().map((consent, index) => {
                const status = getStateGdprConsent(consent.status);

                let consentSummary;

                if (consent.status === OKCONSENTS_NEGATIVE_VALUE && !!consent.channels && consent.channels.length > 0) {
                    consentSummary = buildLastStepInformation(immConsentsGdpr.getIn(['consents', index]));
                } else {
                    consentSummary = <FormattedText value={status} />;
                }

                return(
                    <div className="col-xs-12 content-no-padding consent-change-info__margin-top-consent" key={index.toString()}>
                        <p>
                            <strong>
                                <FormattedText value={consent.consentCell.poEditorTitle} />
                            </strong>
                        </p>
                        <p className="status-text">
                            {consentSummary}
                        </p>
                    </div>
                )
            });

            const consentContainerClass = contactCenterClassName('no-print-out');

            return (
                <div className="row consent-change-info">
                    <div className="col-xs-12 consent-change-info__header">
                        <h3 className={consentContainerClass}><FormattedText value="consents-confirmationSteps" /></h3>
                        <p><FormattedText value="consents-confirmationStepsDescription" /></p>
                    </div>
                    {consentsBuild}
                </div>
            )
        }
    }

    getNextButtonConfig(){
        const { immConsentsGdpr } = this.props;
        let isDisabled = false;

        if (!immConsentsGdpr.get('isFetching') && immConsentsGdpr.get('fetchSuccess') && immConsentsGdpr.get('consentsIsEqualsToInitial')) {
            isDisabled = true;
        }

        return {
            isDisabled,
        };
    }

    renderConsentWizard() {
        const { immConsentsProfile, immConsentsGdpr } = this.props;
        const steps = immConsentsProfile.get('steps');
        const stepsAmount = steps.size;
        const nextButtonConfig = this.getNextButtonConfig();
        const immFinalButton = 'consents-finalButtonOTP';

        // Robinson depends on load to avoid advertisement blink. We need to mark robinson as true, and
        // wait to stop fetching robinson, to set its value.

        const robinsonUser = immConsentsGdpr.get('isFetching') ? true : immConsentsGdpr.get('robinson');
        const headerDescription = immConsentsGdpr.get('isFetching') ? '' : immConsentsGdpr.getIn(['placementViewInfo', 'poEditorBody']);
        const advertisement = this.buildAdvertisement(robinsonUser);
        const printTitleValue = (__CONTACT_CENTER__) ? 'consentChange-pageTitle' : '';

        const actions = {
            finish: this.onFinish,
            setWillCancel: (() => { }),
            cancel: this.cancel,
            setVisibleStep: this.setVisibleStep,
            validateStep: this.validateStep
        };

        return (
            <Wizard
                stepsAmount={stepsAmount}
                visibleStep={immConsentsProfile.get('visibleStep')}
                showPreLeaveModal={true}
                actions={actions}
                onConfirmLeave={() => { }}
                immSteps={immConsentsProfile.get('steps')}
            >
                <WizardStep
                    position="first"
                    key={1}
                    cancelButton={true}
                    nextButtonDisabled={nextButtonConfig.isDisabled}
                >
                    <h3 className="consent-change-info__title-first-step">
                        <FormattedText value="gdpr-titleConsentFirstStep" />
                    </h3>
                    {
                        headerDescription && <p className="consent-change-info__description-title">
                            <FormattedText value={headerDescription} />
                        </p>
                    }
                    <OKConsents
                        getAllConsents={true}
                        placementId="profile"
                        quickAcceptMode={false}
                        handleAcceptAll={this.onGdprAcceptAll}
                        handleChangeValue={this.onGdprChangeValue}
                    />
                    {advertisement}
                    {
                        !immConsentsGdpr.get('isFetching') && immConsentsGdpr.get('fetchSuccess') &&
                            <p className='consent-change-info__gdpr_text'>
                                <FormattedText value="CopyConsentsGDPR-gdpr_consents_text" />
                                <a href={formatText("CopyConsentsGDPR-gdpr_consents_url")} target="_blank"> <FormattedText value="CopyConsentsGDPR-gdpr_consents_textlink" /></a>
                            </p>
                    }
                </WizardStep>
                <WizardStep
                    position="last"
                    key={2}
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    { this.renderLastStepInformation() }
                    <GDPRSignaturePatternSimple printTitleValue={printTitleValue}
                        operationParams={{}}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        return (
            <div className="my-profile-consent-change" >
                {this.renderConsentWizard()}
            </div>
        )
    }
}

ConsentChange.propTypes = {
    history: PropTypes.object.isRequired,
    immConsentsProfile: PropTypes.object,
    immConsentsGdpr: PropTypes.object,
    updateConsents: PropTypes.func,
    handleUpdateConsents: PropTypes.func,
    nextStep: PropTypes.func,
    lastStep: PropTypes.func,
    updateAllConsentsStatus: PropTypes.func.isRequired,
};

module.exports.ConsentChange = connect(
    null
)(withRouter(ConsentChange));
